import { render, staticRenderFns } from "./MeEventos.vue?vue&type=template&id=172220fc&scoped=true"
import script from "./MeEventos.vue?vue&type=script&lang=js"
export * from "./MeEventos.vue?vue&type=script&lang=js"
import style0 from "./MeEventos.vue?vue&type=style&index=0&id=172220fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172220fc",
  null
  
)

export default component.exports